import React from "react";

import "./keywordDisplay.css";

interface KeywordDisplayProps {
    name: string;
}

export default function KeywordDisplay(props: KeywordDisplayProps) {
    return (
        <a className="keyword-link" href={"/pieces?keywords=" + props.name}>
            <div className="keyword-display">
                <h4 className="keyword-name">{props.name}</h4>
            </div>
        </a>
    );
}